// Sentry initialization should be imported first! (see Sentry docs)
import './sentry';
import { createRoot } from 'react-dom/client';
import './index.css';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { setScrollbarGutter } from './utils';
import './i18n';
import './dayjs';
import '@globalmed/atlas-ui/dist/enGlobalStyles.css';
import '@globalmed/atlas-ui/dist/enTheme.css';
import '@globalmed/atlas-ui/dist/atlas-ui.css';

void Promise.all([
  import('@/bridge/medwand/emulator'),
  import('@/components/MedWandEmulatorPanel'),
]).then(([{ installMedWandEmulator }, { mountMedWandEmulatorPanel }]) => {
  installMedWandEmulator();
  // Mounted after the install, so the panel finds the emulator's control handle.
  mountMedWandEmulatorPanel();
});

setScrollbarGutter();

createRoot(document.getElementById('root')!).render(
  <RouterProvider router={router} />,
);
